import React from 'react';
import './Footer.css';


function Footer() {
  return (
    <footer className="footer">
      <p>Made By Medani Tripathi</p>
    </footer>
  );
}

export default Footer;

